import { RequestUserParam, User } from '@/repositories/data'
import { Axios } from 'axios'
import { http } from '@/repositories/http'

export interface UserRepository {
  list(): Promise<User[]>;
  get(userKey: string): Promise<User>;
  add(request: RequestUserParam): Promise<User>;
  modify(userKey: string, request: RequestUserParam): Promise<User>;
  delete(userKey: string): void;
  initializePassword(userKey: string): void;
  sendWelcomeUser(userKey: string): void;
  sendWelcomeAllUser(): void;
}

export class UserRepositoryImpl implements UserRepository {
  constructor (http: Axios) {
    this.http = http
  }

  private readonly http: Axios
  private readonly baseUrl = 'admin/user'

  async list (): Promise<User[]> {
    const { data } = await this.http.get(this.baseUrl)
    return data
  }

  async get (userKey: string): Promise<User> {
    const { data } = await this.http.get(`${this.baseUrl}/${userKey}`)
    return data
  }

  async add (request: RequestUserParam): Promise<User> {
    const { data } = await this.http.post(this.baseUrl, request)
    return data
  }

  async modify (userKey: string, request: RequestUserParam): Promise<User> {
    const { data } = await this.http.put(`${this.baseUrl}/${userKey}`, request)
    return data
  }

  async delete (userKey: string) {
    await this.http.delete(`${this.baseUrl}/${userKey}`)
  }

  async initializePassword (userKey: string) {
    await this.http.post(`${this.baseUrl}/${userKey}/initialize-password`)
  }

  async sendWelcomeUser (userKey: string) {
    await this.http.post(`${this.baseUrl}/${userKey}/send-welcome-user`)
  }

  async sendWelcomeAllUser () {
    await this.http.post(`${this.baseUrl}/send-welcome-all-user`)
  }
}

export const userRepository = new UserRepositoryImpl(http)
